module.exports = __webpack_public_path__ + "static/media/11.230797ba.jpg";